import { render, staticRenderFns } from "./PopupSearchUser.vue?vue&type=template&id=02049fa4&scoped=true"
import script from "./PopupSearchUser.vue?vue&type=script&lang=js"
export * from "./PopupSearchUser.vue?vue&type=script&lang=js"
import style0 from "./PopupSearchUser.vue?vue&type=style&index=0&id=02049fa4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02049fa4",
  null
  
)

export default component.exports